import React from 'react'
import MaleUser from '../../assets/images/Male User.png'
import ChevronRight from '../../assets/images/Chevron Right.png'

const Transactions = () => {
    const remainToClaimsData = [
        {
            "id": 1,
            "date": "30/08/2023",
            "agent": "Ko Jam",
            "remain": "-700000",
            "paid": "+550000",
            "final": "-150000",
        },
        {
            "id": 2,
            "date": "30/08/2023",
            "agent": "Ko Aung",
            "remain": "-100000",
            "paid": "+80000",
            "final": "-20000",
        },
        {
            "id": 3,
            "date": "30/08/2023",
            "agent": "Ko Mg Mg",
            "remain": "-21000",
            "paid": "0",
            "final": "-21000",
        },
    ]

    const recentTransactionsData = [
        {
            "id": 1,
            "dateAndTime": "30/08/2023 - 01:30pm",
            "from": "AKM",
            "to": "Shark",
            "amount": 700000,
            "transactionType": "Kpay",
            "description": "Mon-Fri Weekly"
        },
        {
            "id": 2,
            "dateAndTime": "30/08/2023 - 01:30pm",
            "from": "Bo Bo",
            "to": "AKM",
            "amount": 500000,
            "transactionType": "KBZ Bank",
            "description": "Gold Label"
        },
        {
            "id": 3,
            "dateAndTime": "30/08/2023 - 01:30pm",
            "from": "Ko ANgae",
            "to": "Bo Bo",
            "amount": 120000,
            "transactionType": "Cash",
            "description": "Message Site"
        },
        {
            "id": 4,
            "dateAndTime": "30/08/2023 - 05:30pm",
            "from": "Ko Demo",
            "to": "Bo Bo",
            "amount": 150000,
            "transactionType": "Kpay",
            "description": "Mon-Fri Weekly"
        },
    ]

    // Generate `Remain To Claims` Rows
    const remainToClaimsRows = remainToClaimsData?.map((claim) => {
        return (
            <tr className='border-b-2' key={claim.id}>
                <td className='text-left py-4 px-4 text-fgColor font-semibold pl-16'>{claim.date}</td>
                <td className='text-left py-4 px-4 text-fgColor font-semibold'>{claim.agent}</td>
                <td className='text-right py-4 px-4 text-fgColor font-semibold'>{claim.remain}</td>
                <td className='text-right py-4 px-4 text-fgColor font-semibold'>{claim.paid}</td>
                <td className='text-right py-4 px-4 text-attractive2 font-semibold'>{claim.final}</td>
                <td className="text-center py-4 px-4 text-fgColor font-semibold">
                    <button className='px-8 py-2 bg-primary text-white rounded'>Edit</button>
                </td>
                <td>
                    <img src={ChevronRight} alt="chevron-right-logo" className="w-6 fgColor cursor-pointer" />
                </td>
            </tr>
        )
    })

    // Generate `Recent Transactions` Rows
    const recentTransactionsRows = recentTransactionsData?.map((data) => {
        return (
            <tr className='border-b-2' key={data.id}>
                <td className='text-left py-4 px-4 text-fgColor font-semibold pl-16'>{data.dateAndTime}</td>
                <td className='text-left py-4 px-4 text-fgColor font-semibold'>{data.from}</td>
                <td className='text-left py-4 px-4 text-fgColor font-semibold'>{data.to}</td>
                <td className='text-left py-4 px-4 text-fgColor font-semibold'>{data.amount}</td>
                <td className='text-left py-4 px-4 text-fgColor font-semibold'>{data.transactionType}</td>
                <td className='text-left py-4 px-4 text-fgColor font-semibold'>{data.description}</td>
            </tr>
        )
    })

    return (
        <div>
            <div className='w-[90%] mx-auto borderColor h-[88vh]'>

                <div className="flex gap-2 pt-2 pb-2">
                    <img src={MaleUser} alt="male-user-logo" className="w-6 fgColor" />
                    <p className="font-bold text-fgColor">/</p>
                    <p className="font-bold text-fgColor"> User</p>
                    <p className="font-bold text-fgColor">/</p>
                    <p className="font-bold text-fgColor"> Transactions</p>
                </div>

                {/* Card grid */}
                <div className="mt-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        {/* Card Component */}
                        <div className="p-4 shadow rounded bg-rectangle">
                            <div className="flex justify-between items-center">
                                <div className="flex flex-col gap-2 mb-5">
                                    <h2 className="text-xl font-semibold text-fgColor">Basic Fund</h2>
                                    <p className="text-2xl font-bold">220,700,000</p>
                                </div>
                                <p className="text-primary font-bold">78%</p>
                            </div>
                            {/* Progress Bar */}
                            <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600">
                                <div className="h-2 bg-primary" style={{ width: "78%" }}></div>
                            </div>
                        </div>

                        {/* Card Component */}
                        <div className="p-4 shadow rounded bg-rectangle">
                            <div className="flex justify-between items-center">
                                <div className="flex flex-col gap-2 mb-5">
                                    <h2 className="text-xl font-semibold text-fgColor">Fund In Holder</h2>
                                    <p className="text-2xl font-bold">127,700,000</p>
                                </div>
                                <p className="text-attractive1 font-bold">88%</p>
                            </div>
                            {/* Progress Bar */}
                            <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600">
                                <div className="h-2 bg-attractive1" style={{ width: "88%" }}></div>
                            </div>
                        </div>

                        {/* Card Component */}
                        <div className="p-4 shadow rounded bg-rectangle">
                            <div className="flex justify-between items-center">
                                <div className="flex flex-col gap-2 mb-5">
                                    <h2 className="text-xl font-semibold text-fgColor">Remain to Claim</h2>
                                    <p className="text-2xl font-bold">820,000</p>
                                </div>
                                <p className="text-attractive2 font-bold">27%</p>
                            </div>
                            {/* Progress Bar */}
                            <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600">
                                <div className="h-2 bg-attractive2" style={{ width: "27%" }}></div>
                            </div>
                        </div>

                        {/* Card Component */}
                        <div className="p-4 shadow rounded bg-rectangle">
                            <div className="flex justify-between items-center">
                                <div className="flex flex-col gap-2 mb-5">
                                    <h2 className="text-xl font-semibold text-fgColor">Agent</h2>
                                    <p className="text-2xl font-bold">220</p>
                                </div>
                            </div>
                            {/* Progress Bar */}
                            <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600">
                                <div className="h-2 bg-yellow-400" style={{ width: "47%" }}></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Remain To Claim section */}
                <div className="mt-8 p-4 bg-rectangle shadow rounded pl-16 pr-16">
                    <h2 className="text-xl font-semibold mb-4 text-primary">Remain To Claim</h2>
                    <table className="min-w-full bg-rectangle mb-5">
                        <thead className='border-b-2'>
                            <tr>
                                <th className='py-4 px-4 text-fgColor text-left pl-16'>Date</th>
                                <th className='py-4 px-4 text-fgColor text-left'>Agent</th>
                                <th className='py-4 px-4 text-fgColor text-right'>Remain</th>
                                <th className='py-4 px-4 text-fgColor text-right'>Paid</th>
                                <th className='py-4 px-4 text-fgColor text-right'>Final</th>
                                <th className='py-4 px-4 text-fgColor text-center'>Action</th>
                                <th className='py-4 px-4 text-fgColor text-left'></th>
                            </tr>
                        </thead>
                        <tbody>
                            {remainToClaimsRows}
                        </tbody>
                    </table>
                </div>

                {/* Recent Transactions Section */}
                <div className="mt-8 p-4 bg-rectangle shadow rounded pl-16 pr-16 mb-10">
                    <h2 className="text-xl font-semibold mb-4 text-primary">Recent Transactions (Bo Bo _ ShareHolder)</h2>
                    <table className="min-w-full bg-rectangle mb-5">
                        <thead className='border-b-2'>
                            <tr>
                                <th className='py-4 px-4 text-fgColor text-left pl-16'>Date & Time</th>
                                <th className='py-4 px-4 text-fgColor text-left'>From</th>
                                <th className='py-4 px-4 text-fgColor text-left'>To</th>
                                <th className='py-4 px-4 text-fgColor text-left'>Amount</th>
                                <th className='py-4 px-4 text-fgColor text-left'>Transaction Type</th>
                                <th className='py-4 px-4 text-fgColor text-left'>Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recentTransactionsRows}
                        </tbody>
                    </table>
                </div>

                <div className="h-5">
                </div>
            </div>
        </div>
    )
}

export default Transactions
